import {imageMap} from "../../images/imageMap.ts";

export default function TDC5GSetupStepsSectionComponent() {
    return (
        <section className="mbb-steps">
            <div className="content content--medium">
                <h2 className="heading heading--montserrat heading--big">Så let er det!</h2>
                <div className="box-container">
                    <div className="box">
                        <div className="image-container">
                            <img
                                src={imageMap.products.mbb_how_to_simkort}
                                alt="Opsætning af 5G-internet &ndash; Trin 1: Indsæt SIM-kortet i routeren."
                            />
                            <span className="number">1</span>
                        </div>
                        <p>Indsæt SIM-kort i routeren</p>
                    </div>
                    <div className="box">
                        <div className="image-container">
                            <img
                                src={imageMap.products.mbb_how_to_stikkontakt}
                                alt="Opsætning af 5G-internet &ndash; Trin 2: Sæt stikket i stikkontakten."
                            />
                            <span className="number">2</span>
                        </div>
                        <p>Tilslut routeren til strøm</p>
                    </div>
                    <div className="box">
                        <div className="image-container">
                            <img
                                src={imageMap.products.mbb_how_to_stikkontakt_taend}
                                alt="Opsætning af 5G-internet &ndash; Trin 3: Tænd for stikkontakten."
                            />
                            <span className="number">3</span>
                        </div>
                        <p>Tænd for stikkontakten</p>
                    </div>
                </div>
            </div>
        </section>
    )
}
